import { useFeatureValue } from "@growthbook/growthbook-react";

/**
 * Resolves the special-offers holdout arm. `eligible` is the caller's own
 * offer-present + billing gate; the GrowthBook condition handles paid exclusion.
 * inHoldout is true only when the user is eligible AND bucketed into the holdout arm.
 * `arm` is the raw bucket ("show" | "holdout"), exposed so call sites can stamp it
 * onto analytics events as offer_arm for per-arm CTR breakdown in GA4.
 */
export function useSpecialOfferExperiment(eligible: boolean): { inHoldout: boolean; arm: string } {
  const arm = useFeatureValue("special-offers-holdout", "show");
  return { inHoldout: eligible && arm === "holdout", arm };
}
